<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.667969 8.00065C0.667969 5.42332 2.75731 3.33398 5.33464 3.33398H10.668C13.2453 3.33398 15.3346 5.42332 15.3346 8.00065C15.3346 10.578 13.2453 12.6673 10.668 12.6673H5.33464C2.75731 12.6673 0.667969 10.578 0.667969 8.00065ZM5.33464 4.66732C3.49369 4.66732 2.0013 6.1597 2.0013 8.00065C2.0013 9.8416 3.49369 11.334 5.33464 11.334H10.668C12.5089 11.334 14.0013 9.8416 14.0013 8.00065C14.0013 6.1597 12.5089 4.66732 10.668 4.66732H5.33464ZM10.668 7.00065C10.1157 7.00065 9.66797 7.44837 9.66797 8.00065C9.66797 8.55294 10.1157 9.00065 10.668 9.00065C11.2203 9.00065 11.668 8.55294 11.668 8.00065C11.668 7.44837 11.2203 7.00065 10.668 7.00065ZM8.33463 8.00065C8.33463 6.71199 9.3793 5.66732 10.668 5.66732C11.9566 5.66732 13.0013 6.71199 13.0013 8.00065C13.0013 9.28932 11.9566 10.334 10.668 10.334C9.3793 10.334 8.33463 9.28932 8.33463 8.00065Z"
      fill="#191414"
    />
  </svg>
</template>

<style lang="scss" scoped>
svg {
  width: 100%;
  height: 100%;
}
</style>
